
const responsiveIframes = ( () => {
	const videoContainerClass = 'video-container'
	// utilty fxn
	const wrap = ( el, wrapper ) => {
		el.parentNode.insertBefore( wrapper, el );
		wrapper.appendChild( el );
	}

	const wrapAll = ( addedClass ) => {
		const els = Array.from( document.getElementsByTagName( 'iframe' ) );
		const cont = document.createElement( 'div' );
		cont.classList = `plyr__video-embed ${videoContainerClass}  ${addedClass}`;
		els.forEach( ( item, i ) => {
			// const w = Number(item.getAttribute('width'));
			// const h = Number(item.getAttribute('height'));

			cont.id = `video-container-${i}`;
			// cont.style.aspectRatio = w / h;
			wrap( item, cont );
		} )
	}

	return {
		all: wrapAll
	}
} )();


